module.exports = __webpack_public_path__ + "img/kachel-ERSCHOEPFUNG_ALOEVERATRINKGELE.a77177eb.png";